<template>
  <section class="rules-content">
    <b-container class="h-100">
      <b-row class="h-100">
        <b-col sm="12">
          <div class="card-rules-container">
            <Scrollama @step-enter="stepEnterHandler" :offset="0.8">
              <div class="card-rules-box appear" data-step="1">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/maintenance-of-dogs-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/maintenance-of-dogs-ua.svg" alt="IRules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/maintenance-of-dogs-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('maintenance_of_dogs_title')}}</h4>
                  <p class="text">{{$t('maintenance_of_dogs_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="2">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/dog-walking-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/dog-walking-ua.svg" alt="IRules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/dog-walking-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('dog_walking_title')}}</h4>
                  <p class="text">{{$t('dog_walking_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="3">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/transportation-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/transportation-ua.svg" alt="IRules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/transportation-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content" data-step="4">
                  <h4 class="title">{{$t('transportation_title')}}</h4>
                  <p class="text">{{$t('transportation_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="5">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/entering-the-country-with-a-dog-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/entering-the-country-with-a-dog-ua.svg" alt="IRules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/entering-the-country-with-a-dog-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('entering_the_country_title')}}</h4>
                  <p class="text">{{$t('entering_the_country_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="6">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/veterinarian-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/veterinarian-ua.svg" alt="IRules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/veterinarian-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('veterinarian_title')}}</h4>
                  <p class="text">{{$t('veterinarian_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="7">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/fines-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/fines-ua.svg" alt="Rules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/fines-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('fines_title')}}</h4>
                  <p class="text">{{$t('fines_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="8">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/dangerous-breeds-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/dangerous-breeds-ua.svg" alt="Rules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/dangerous-breeds-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('dangerous_title')}}</h4>
                  <p class="text">{{$t('dangerous_text')}}</p>
                </div>
              </div>
              <div class="card-rules-box appear" data-step="9">
                <div class="card-rules-img">
                  <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/users-info/airlines-en.svg" alt="Rules image">
                  <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/users-info/airlines-ua.svg" alt="Rules image">
                  <img v-else class="main-photo" src="../../assets/img/users-info/airlines-en.svg" alt="Rules image">
                </div>
                <div class="card-rules-content">
                  <h4 class="title">{{$t('airlines_title')}}</h4>
                  <p class="text">{{$t('airlines_text')}}</p>
                </div>
              </div>
            </Scrollama>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Scrollama from 'vue-scrollama'
export default {
  data () {
    return {

    }
  },
  components: {
    Scrollama
  },
  methods: {
    stepEnterHandler ({ element }) {
      element.classList.add('appearing')
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/sass/app";
.appear {
  opacity: 0;
  transform: translateY(50px); /* Зміна положення по вертикалі */
  transition: opacity 0.5s ease, transform 0.5s ease; /* Анімація з'явлення */
}

.appear.appearing {
  opacity: 1;
  transform: translateY(0); /* Повернення до початкового положення */
}
.rules-content{
  @media screen and (min-width: 320px) {
    overflow: hidden;
  }
}
.card-rules-container{
  width: 100%;
  .card-rules-box {
    display: flex;
    justify-content: stretch;
    align-items: center;
    width: 100%;
    gap: 20px;
    @media screen and (min-width: 320px) {
      flex-direction: column;
    }
    @media screen and (min-width: 768px) {
      flex-direction: row;
    }
    .card-rules-img {
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        max-width: 610px;
        width: 100%;
        height: auto;
        @media screen and (min-width: 320px) {
          min-width: 349px;
        }
        @media screen and (min-width: 768px) {
          min-width: unset;
        }
      }
    }
    .card-rules-content{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      max-width: 535px;
      gap: 16px;
      font-family: $main-font;
      color: #30394B;
      .title{
        font-size: 24px;
        font-weight: 700;
        line-height: 28.8px;
        margin: 0;
      }
      .text{
        font-size: 18px;
        font-weight: 300;
        line-height: 25.2px;
        text-align: left;
      }
    }
  }
}
</style>
